import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import groupService from "../../service/group";
import { Group, GroupState } from "../../@type/group";


export const getGroup = createAsyncThunk(
    "get/getGroup",
    async () => {
      const { data } = await groupService.get();
      return data;
    }
  );
  export const getByGroupId = createAsyncThunk(
    "get/getByIDGroup",
    async (id: number) => {
      const { data } = await groupService.getById(id);
      return data;
    }
  );
  export const postGroup = createAsyncThunk(
    "post/postGroup",
    async (GroupData: any) => {
      const { data } = await groupService.post(GroupData);
      return data;
    }
  );
     export const updateGroup = createAsyncThunk(
    "update/updateOtherType",
    async ({ id, a }: { id: number, a: Group }) => {
      const { data } = await groupService.updateById(id, a);
      return data;
    }
  );
       export const deleteGroup = createAsyncThunk(
    "delete/deleteGroup",
    async (id: number) => {
      const { data } = await groupService.delete(id);
      return data;
    }
  );
const initialState: GroupState = {
  groupList: [],
  groupDetail: {
    groupId:0,
    groupName:"",
    description:"",
    image:""
  }
};

const GroupSlice = createSlice({
  name: "Group",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getGroup.fulfilled, (state, action) => {
      state.groupList = action.payload.data;
    });
    builder.addCase(postGroup.fulfilled, (state, action) => {
      state.groupList.push(action.payload);
    });
    builder.addCase(getByGroupId.fulfilled, (state, action) => {
      state.groupDetail = action.payload.data;
    });
     builder.addCase(deleteGroup.fulfilled, (state, action) => {
          state.groupList.push(action.payload);
        }); 
  },
});

export default GroupSlice.reducer;
